import { useEffect, useState } from 'react'
import { useMediaQuery } from '@material-ui/core'

export const useFetch = <T,>(
  url: string
): [SpreadSheetType<T> | undefined, boolean] => {
  const [data, setData] = useState<SpreadSheetType<T>>()
  const [error, setError] = useState<boolean>(false)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url)
        const json = await res.json()
        setData(json)
        setError(false)
      } catch {
        setError(true)
      }
    }
    fetchData()
  }, [url])

  return [data, error]
}

const mediaQueries = {
  mobile: '(max-width: 519px)',
  tablet: '(min-width: 520px) and (max-width: 959px)',
  pc: '(min-width: 960px)'
}

type GridProps = {
  cellHeight: number
  cols: number
}

export const useGridSize = (mobile = 2, tablet = 3, pc = 4): GridProps => {
  const isMobileSite = useMediaQuery(mediaQueries.mobile)
  const isTabletSite = useMediaQuery(mediaQueries.tablet)
  const isPcSite = useMediaQuery(mediaQueries.pc)

  switch (true) {
    case isMobileSite:
      return { cellHeight: 200, cols: mobile }
    case isTabletSite:
      return { cellHeight: 280, cols: tablet }
    case isPcSite:
      return { cellHeight: 340, cols: pc }
    default:
      return { cellHeight: 220, cols: mobile }
  }
}

const BASE_URL =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vQdex2n6nPeJe240AdmfRkJR2b-WHTFvGcouhdYfSMpqaWVMi9kvnp-9SHZYQ7kMp8cLoChXyltxepq/pub?output=csv'

type CsvResponse<T extends Csv> = {
  header: (keyof T)[]
  body: T[]
}

export const useFetchCSV = <T extends Csv>(
  gid: string
): [CsvResponse<T> | undefined, boolean] => {
  const [data, setData] = useState<T[]>([])
  const [headers, setHeaders] = useState<(keyof T)[]>([])
  const [error, setError] = useState<boolean>(false)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${BASE_URL}&gid=${gid}&single=true`)
        const csv = await res.text()
        const [header, ...body] = csv.split('\r\n').map((e) => e.split(','))
        const d: T[] = body.map((e) => {
          return e.reduce(
            (pre, cur, i) => ({ ...pre, [header[i]]: cur }),
            {}
          ) as T
        })
        setHeaders(Object.keys(d[0]) as (keyof T)[])
        setData(d)
        setError(false)
      } catch {
        setError(true)
      }
    }
    fetchData()
  }, [gid])

  return [{ header: headers, body: data }, error]
}
